const KEYS = ['pricedByOrder', 'noPriceRule', 'noPrice', 'noEngineVolume'];

// Счётчики цен из ответа бэка (StockImportResult). Карточка итогов читает их из result —
// без явного переноса в состояние она всегда показывала бы 0. carWarnings — те же
// замечания поимённо (по каким машинам)
export const importCounters = (data) => ({
  ...Object.fromEntries(KEYS.map((k) => [k, data?.[k] ?? 0])),
  carWarnings: data?.carWarnings ?? [],
});

// Ручная правка строк досылает ещё машины — их счётчики прибавляются к уже показанным
export const addImportCounters = (prev, data) => ({
  ...Object.fromEntries(KEYS.map((k) => [k, (prev?.[k] ?? 0) + (data?.[k] ?? 0)])),
  carWarnings: [...(prev?.carWarnings ?? []), ...(data?.carWarnings ?? [])],
});
